export function rem(px: number): string {
  return `${px / 16}rem`;
}
